<template>
   <v-container fluid style="margin-top: -12px; padding-right: 0px;"> 
      <DataViewer ref="dataViewer" style="padding-right: 0px;"/>
    </v-container>
</template>

<script> 
import BaseModule from '../../common/BaseModule.js'
import CommonFormatter from '../../common/CommonFormatter.js'
import DataViewer from "../qb/DataViewer";
//import api from '../../../api/worktime'
import { getHqlQuery, getAllColumns} from '../qb/QBUtils'

export default {
  name: 'QBWidget',
  mixins: [BaseModule, CommonFormatter],
  components: { 
      DataViewer
  },
   props: ['config','context'],
  
  data() {
      return {
        isLoading: true,
        options: {},
        headers: [],
        data: [],
        queryConfig: {},
        tableHeight:200
      }
  },mounted() {
    this.loadData();
    },
    watch: {
      options: {
        handler () { 
            this.loadData();
        },
        deep: true,
      },
      context: function() { 
        this.update();
      }
    },
   methods: {
    loadData() {
    
        if (!this.config && !this.config.fields) {
            return;
        }
        const me = this;
        me.isLoading=true;
        me.queryConfig = JSON.parse(me.config.fields);
        this.$nextTick(() => {
          if (!me.queryConfig.addedColumns || me.queryConfig.addedColumns.length==0) {
            me.queryConfig.addedColumns = getAllColumns(me.queryConfig.entity);
          }
          me.queryConfig.rawQuery = getHqlQuery(me.queryConfig.entity, me.queryConfig.addedFilters);
          me.queryConfig.tableHeight=408;
          me.queryConfig.autoFixTableHeight = false;
          me.queryConfig.showHeader = false;
          this.$refs.dataViewer.executeQuery(me.queryConfig);
        });
    },
    
    update() {
        this.loadData(this);
    },

   }
};
</script>
 